<template>
  <div class="tb">
    <div v-if="selected.length" class="tb__bulk">
      <span class="tb__bulk-count">{{ $t('crmSelectedCount', { n: selected.length }) }}</span>
      <slot name="bulk" :ids="selected.map(r => r.id)" :clear="() => (selected = [])" />
      <v-spacer />
      <button type="button" class="tb__bulk-x" @click="selected = []"><v-icon small>mdi-close</v-icon></button>
    </div>
    <v-data-table
      v-model="selected"
      :headers="visibleHeaders"
      :items="items"
      :loading="loading"
      :server-items-length="total"
      :options="options"
      :footer-props="{ itemsPerPageOptions: [20, 50, 100] }"
      :show-select="selectable"
      item-key="id"
      fixed-header
      height="100%"
      class="tb__table"
      dense
      @update:options="$emit('update:options', $event)"
      @click:row="r => $emit('open', r)"
    >
      <template v-for="h in headers" #[`item.${h.value}`]="{ item }">
        <slot :name="'cell.' + h.value" :item="item">{{ item[h.value] }}</slot>
      </template>
      <template #[`header.data-table-select`]="{ props, on }">
        <v-simple-checkbox :value="props.value" :indeterminate="props.indeterminate" v-on="on" />
      </template>
      <template #no-data>
        <slot name="empty" />
      </template>
    </v-data-table>
    <v-menu offset-y left :close-on-content-click="false">
      <template #activator="{ on }">
        <button type="button" class="tb__cols" :title="$t('crmColumns')" v-on="on"><v-icon small>mdi-table-cog</v-icon></button>
      </template>
      <div class="tb__colmenu">
        <div class="tb__colmenu-title">{{ $t('crmColumns') }}</div>
        <v-checkbox
          v-for="h in headers.filter(x => !x.fixed)"
          :key="h.value"
          v-model="shown"
          :value="h.value"
          :label="h.text"
          dense
          hide-details
        />
      </div>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'CrmTable',
  props: {
    headers: { type: Array, required: true },
    items: { type: Array, default: () => [] },
    total: { type: Number, default: 0 },
    loading: Boolean,
    options: { type: Object, default: () => ({}) },
    selectable: { type: Boolean, default: true },
    storageKey: { type: String, default: '' }
  },
  data () {
    let shown = null
    try { shown = JSON.parse(localStorage.getItem('crm-cols:' + this.storageKey)) } catch (e) { shown = null }
    return { selected: [], shown: shown || this.headers.filter(h => !h.hidden).map(h => h.value) }
  },
  computed: {
    visibleHeaders () { return this.headers.filter(h => h.fixed || this.shown.includes(h.value)) }
  },
  watch: {
    shown (v) { try { localStorage.setItem('crm-cols:' + this.storageKey, JSON.stringify(v)) } catch (e) { /* ignore */ } },
    items () { this.selected = this.selected.filter(s => this.items.some(i => i.id === s.id)) }
  }
}
</script>

<style scoped>
.tb { position: relative; display: flex; flex-direction: column; height: 100%; min-height: 0; background: #fff; border: 1px solid rgba(15, 23, 42, .08); border-radius: 6px; overflow: hidden; }
.theme--dark .tb { background: #1e1e1e; border-color: rgba(255, 255, 255, .1); }
.tb__bulk { display: flex; align-items: center; gap: 8px; padding: 8px 14px; background: rgba(25, 118, 210, .08); border-bottom: 1px solid rgba(25, 118, 210, .18); flex-shrink: 0; flex-wrap: wrap; }
.tb__bulk-count { font-size: .82rem; font-weight: 700; color: var(--v-primary-base); margin-inline-end: 6px; }
.tb__bulk-x { width: 28px; height: 28px; border-radius: 6px; display: inline-flex; align-items: center; justify-content: center; }
.tb__table { flex: 1; min-height: 0; display: flex; flex-direction: column; }
.tb__table ::v-deep .v-data-table__wrapper { flex: 1; min-height: 0; }
.tb__table ::v-deep th { font-size: .74rem !important; font-weight: 700 !important; white-space: nowrap; background: #f8f9fc !important; }
.theme--dark .tb__table ::v-deep th { background: #232323 !important; }
.tb__table ::v-deep td { font-size: .82rem !important; height: 46px !important; white-space: nowrap; }
.tb__table ::v-deep tbody tr { cursor: pointer; }
.tb__table ::v-deep tbody tr:hover { background: rgba(25, 118, 210, .04) !important; }
.tb__table ::v-deep .v-data-footer { flex-shrink: 0; }
.tb__cols { position: absolute; top: 6px; inset-inline-end: 8px; width: 30px; height: 30px; border-radius: 6px; background: rgba(127, 127, 127, .1); display: inline-flex; align-items: center; justify-content: center; z-index: 3; }
.tb__colmenu { background: #fff; padding: 12px 14px; border-radius: 6px; }
.theme--dark .tb__colmenu { background: #1e1e1e; }
.tb__colmenu-title { font-weight: 700; font-size: .82rem; margin-bottom: 6px; }
.tb__colmenu ::v-deep .v-input { height: auto !important; margin-top: 4px; }
</style>
